module.exports = __webpack_public_path__ + "img/obszary-parkingowe.b81d8443.svg";